import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

interface ErrorMessageProps {
    message: string;
    onRetry?: () => void;
    className?: string;
    variant?: 'inline' | 'card';
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({
                                                              message,
                                                              onRetry,
                                                              className = '',
                                                              variant = 'card',
                                                          }) => {
    const baseClasses = variant === 'card'
        ? 'bg-red-50 border border-red-200 rounded-lg p-4'
        : 'bg-red-50 border-l-4 border-red-400 p-3';

    return (
        <div className={`${baseClasses} ${className}`}>
            <div className="flex items-start">
                <AlertTriangle className="h-5 w-5 text-red-400 flex-shrink-0 mt-0.5" />
                <div className="ml-3 flex-1">
                    <h3 className="text-sm font-medium text-red-800">
                        Error
                    </h3>
                    <p className="text-sm text-red-700 mt-1">
                        {message}
                    </p>
                    {onRetry && (
                        <div className="mt-3">
                            <button
                                onClick={onRetry}
                                className="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded text-red-700 bg-red-100 hover:bg-red-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors"
                            >
                                <RefreshCw className="h-3 w-3 mr-1" />
                                Try Again
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ErrorMessage;
